import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useVersionSelectContextMenu } from '../../context';

type DeletePropsType = {
  disabled?: boolean;
};

export const Delete: React.FC<DeletePropsType> = ({ disabled }) => {
  const { t } = useTranslation();
  const { handleDelete, selectedVersion } = useVersionSelectContextMenu();

  return (
    <Menu.Item
      leftSection={
        <FontAwesomeIcon color="var(--mantine-color-red-8)" icon={faTrash} />
      }
      onClick={() => handleDelete(selectedVersion)}
      disabled={disabled}
    >
      {t('VERSION_SELECT.MENU.DELETE')}
    </Menu.Item>
  );
};
